import CorpManagerPanel from './CorpManagerPanel';
import './style/index.less';

export default CorpManagerPanel;
